/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/DialogFlowSession'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./DialogFlowSession'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.DialogScheduleBatchReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.DialogFlowSession);
  }
}(this, function(ApiClient, DialogFlowSession) {
  'use strict';




  /**
   * The DialogScheduleBatchReport model module.
   * @module model/DialogScheduleBatchReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>DialogScheduleBatchReport</code>.
   * @alias module:model/DialogScheduleBatchReport
   * @class
   */
  var exports = function() {
    var _this = this;
















  };

  /**
   * Constructs a <code>DialogScheduleBatchReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DialogScheduleBatchReport} obj Optional instance to populate.
   * @return {module:model/DialogScheduleBatchReport} The populated <code>DialogScheduleBatchReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Sessions')) {
        obj['Sessions'] = ApiClient.convertToType(data['Sessions'], [DialogFlowSession]);
      }
      if (data.hasOwnProperty('DialogScheduleID')) {
        obj['DialogScheduleID'] = ApiClient.convertToType(data['DialogScheduleID'], 'Integer');
      }
      if (data.hasOwnProperty('StartDate')) {
        obj['StartDate'] = ApiClient.convertToType(data['StartDate'], 'Date');
      }
      if (data.hasOwnProperty('EndDate')) {
        obj['EndDate'] = ApiClient.convertToType(data['EndDate'], 'Date');
      }
      if (data.hasOwnProperty('IsSent')) {
        obj['IsSent'] = ApiClient.convertToType(data['IsSent'], 'Boolean');
      }
      if (data.hasOwnProperty('IsClosed')) {
        obj['IsClosed'] = ApiClient.convertToType(data['IsClosed'], 'Boolean');
      }
      if (data.hasOwnProperty('ResultWorkshopID')) {
        obj['ResultWorkshopID'] = ApiClient.convertToType(data['ResultWorkshopID'], 'Integer');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('AgendaThemeID')) {
        obj['AgendaThemeID'] = ApiClient.convertToType(data['AgendaThemeID'], 'Integer');
      }
      if (data.hasOwnProperty('StrategyDescriptionID')) {
        obj['StrategyDescriptionID'] = ApiClient.convertToType(data['StrategyDescriptionID'], 'Integer');
      }
      if (data.hasOwnProperty('Description')) {
        obj['Description'] = ApiClient.convertToType(data['Description'], 'String');
      }
      if (data.hasOwnProperty('SendDate')) {
        obj['SendDate'] = ApiClient.convertToType(data['SendDate'], 'Date');
      }
      if (data.hasOwnProperty('CreatorID')) {
        obj['CreatorID'] = ApiClient.convertToType(data['CreatorID'], 'Integer');
      }
      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Array.<module:model/DialogFlowSession>} Sessions
   */
  exports.prototype['Sessions'] = undefined;
  /**
   * @member {Integer} DialogScheduleID
   * @default 0
   */
  exports.prototype['DialogScheduleID'] = 0;
  /**
   * @member {Date} StartDate
   */
  exports.prototype['StartDate'] = undefined;
  /**
   * @member {Date} EndDate
   */
  exports.prototype['EndDate'] = undefined;
  /**
   * @member {Boolean} IsSent
   * @default false
   */
  exports.prototype['IsSent'] = false;
  /**
   * @member {Boolean} IsClosed
   * @default false
   */
  exports.prototype['IsClosed'] = false;
  /**
   * @member {Integer} ResultWorkshopID
   */
  exports.prototype['ResultWorkshopID'] = undefined;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Integer} AgendaThemeID
   */
  exports.prototype['AgendaThemeID'] = undefined;
  /**
   * @member {Integer} StrategyDescriptionID
   */
  exports.prototype['StrategyDescriptionID'] = undefined;
  /**
   * @member {String} Description
   * @default ''
   */
  exports.prototype['Description'] = '';
  /**
   * @member {Date} SendDate
   */
  exports.prototype['SendDate'] = undefined;
  /**
   * @member {Integer} CreatorID
   * @default 0
   */
  exports.prototype['CreatorID'] = 0;
  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


